import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../store/actions/actions';

import ToggleFullscreen from '../Common/ToggleFullscreen';
import HeaderRun from './Header.run'
import { AuthService,SenderIdService } from '../../services';
class Header extends Component {

    componentDidMount() {
        HeaderRun();
        const user= AuthService.getUsername();
        const username=user.replace(/^"(.*)"$/, '$1')
        const finalUsername = username.charAt(0).toUpperCase() + username.slice(1);
        this.setState({username:finalUsername})
        
    }
    state={
        username:'',
    }

    toggleUserblock = e => {
        e.preventDefault();
        this.props.actions.toggleSetting('showUserBlock');
    }

    toggleOffsidebar = e => {
        e.preventDefault()
        this.props.actions.toggleSetting('offsidebarOpen');
    }

    toggleCollapsed = e => {
        e.preventDefault()
        this.props.actions.toggleSetting('isCollapsed');
        this.resize()
    }

    toggleAside = e => {
        e.preventDefault()
        this.props.actions.toggleSetting('asideToggled');
    }

    logout=()=>{
        SenderIdService.logout().then((res) => {
            this.setState({redirect:"/login"})
        }, (err) => {
            this.setState({redirect:"/login"})
        })
    }

    getUsername(){
      const user= AuthService.getUsername();
      this.setState({username:user.username})
     }
    resize () {
        // all IE friendly dispatchEvent
        var evt = document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
        // modern dispatchEvent way
        // window.dispatchEvent(new Event('resize'));
    }

    partnerLogo = {
        maxWidth: "130px",
        
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect}/>
        }
        return (
            <header className="topnavbar-wrapper">
                { /* START Top Navbar */ }
                <nav className="navbar topnavbar">
                    { /* START navbar header */ }
                    <div className="navbar-header">
                        <a className="navbar-brand">
                            <div className="brand-logo">
                                <img className="img-fluid" src="img/web.png" alt="App Logo" style={this.partnerLogo} />
                            </div>
                            <div className="brand-logo-collapsed">
                                <img className="img-fluid" src="img/web.png" alt="App Logo" />
                            </div>
                        </a>
                    </div>
                    { /* END navbar header */ }

                    { /* START Left navbar */ }
                    <ul className="navbar-nav mr-auto flex-row">
                        <li className="nav-item">
                            { /* Button used to collapse the left sidebar. Only visible on tablet and desktops */ }
                            <a href="" className="nav-link d-none d-md-block d-lg-block d-xl-block" onClick={ this.toggleCollapsed }>
                                <em className="fas fa-bars"></em>
                            </a>
                            { /* Button to show/hide the sidebar on mobile. Visible on mobile only. */ }
                            <a href=""  className="nav-link sidebar-toggle d-md-none" onClick={ this.toggleAside }>
                                <em className="fas fa-bars"></em>
                            </a>
                        </li>
                        { /* START User avatar toggle */ }
                        {/* <li className="nav-item d-none d-md-block">
                            <a  className="nav-link" onClick={ this.toggleUserblock }>
                                <em className="icon-user"></em>
                            </a>
                        </li> */}
                        { /* END User avatar toggle */ }
                        
                    </ul>
                    { /* END Left navbar */ }
                    { /* START Right Navbar */ }
                    <ul className="navbar-nav flex-row" >
                        { /* START user */ }
                        <li className="nav-item d-none text-center d-md-block">
                            <span className="text-white nav-link">Hi {this.state.username}</span>
                        </li>
                        <li className="nav-item d-none d-md-block">
                            <ToggleFullscreen className="nav-link"/>
                        </li>
                        <li className="nav-item d-none d-md-block">
                            <Link onClick={this.logout} title="Log out" className="nav-link">
                                <em className="icon-logout"></em>
                            </Link>
                        </li>
                        { /* END user */ }
                        { /* Fullscreen (only desktops) */ }
                       
                    </ul>
                    { /* END Right Navbar */ }
                </nav>
                { /* END Top Navbar */ }
            </header>
            );
    }

}

Header.propTypes = {
    actions: PropTypes.object,
    settings: PropTypes.object
};

const mapStateToProps = state => ({ settings: state.settings })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);